import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Work = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="work"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.3749 7.31242C14.8459 7.31242 14.4166 6.88309 14.4166 6.35408V4.91656H10.5832V6.35408C10.5832 6.88309 10.1539 7.31242 9.62485 7.31242C9.09584 7.31242 8.6665 6.88309 8.6665 6.35408V4.91656C8.6665 3.85951 9.52614 2.99988 10.5832 2.99988H14.4166C15.4736 2.99988 16.3333 3.85951 16.3333 4.91656V6.35408C16.3333 6.88309 15.9039 7.31242 15.3749 7.31242Z" />
      <path d="M13.1805 15.8225C13.008 15.8896 12.7589 15.9375 12.5001 15.9375C12.2414 15.9375 11.9922 15.8896 11.7622 15.8034L1 12.2192V19.5313C1 20.988 2.17876 22.1668 3.63544 22.1668H21.3648C22.8215 22.1668 24.0002 20.988 24.0002 19.5313V12.2192L13.1805 15.8225Z" />
      <path d="M24.0002 8.51038V10.705L12.7301 14.4617C12.6535 14.4904 12.5768 14.5 12.5001 14.5C12.4235 14.5 12.3468 14.4904 12.2701 14.4617L1 10.705V8.51038C1 7.0537 2.17876 5.87494 3.63544 5.87494H21.3648C22.8215 5.87494 24.0002 7.0537 24.0002 8.51038Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Work.defaultProps = {
  className: null,
};

Work.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Work;
